import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { AreaValidations } from '../../../../models';

import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import FormField from '../../formfield/FormField';

export class AreaInfoForm extends Component {
  render() {
    let area = this.props.area || {site: {}};
    if(!area.id){
      return (<div>Not defined</div>);
    }
    let site = this.props.sites.find(s=>{return s.id === area.site.id});
    
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
         <Field
          name="name"
          label={I18n.t('models.area.name')}
          type="text"
          placeholder={I18n.t('models.area.name')}
          component={FormField}
          maxLength="24"
          validate={AreaValidations.name}
        />
        <Field
          name="site"
          label={I18n.t('models.area.site')}
          type="value"
          component={FormField}
          input={{value: site.name}}
        />
        <Field
          name="location"
          label={I18n.t('models.area.areaLocation')}
          type="value"
          component={FormField}
          input={{value: this.props.area.location}}
        />
        <FormActions>
          <Button>{I18n.t('save')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}

export default reduxForm({
    form: 'editarea',
  })(AreaInfoForm);


// WEBPACK FOOTER //
// ./src/components/forms/editareaform/areainfoform/AreaInfoForm.js